export default {
  tooltip_title: 'Klicken zum Kopieren',
  success: 'Kopiert!',
};
